module.exports = __webpack_public_path__ + "media/images/icons/twotone/mail-98a52ed486dca7f8f0fe6aa2bc3adae3.svg";